import image1 from "../images/Environmental-1.jpg";
import image2 from "../images/Environmental-2.jpg";
import image3 from "../images/Environmental-3.jpg";
import image4 from "../images/Environmental-4.jpg";
import { useState } from "react";
const Environment = () => {
    const [block, setblock] = useState(false);

    function FullView2(ImgLink){
        document.getElementById("FullImage2").src = ImgLink;
        setblock(true);
    }

    function CloseFullView(){
        setblock(false);
    }

    return ( 
        <>
            <div className="main-container">
                    <h2>Environmental Services</h2>
                    <div className="components-section">
                        <div className="comp">
                            <div className="component">Roiling Stock Components</div>
                            <div className="list">
                                <ul>
                                    <li>Provide vegetation services :grass cutting,tree cutting soil poisoning,weed control</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component second">Industrial Cleaning</div>
                            <div className="list">
                                <ul>
                                    <li>Provide industrial cleaning services to various industrial sites</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component">Landscaping</div>
                            <div className="list">
                                <ul>
                                    <li>Designs and implementation,installation of artificial and instant lawn</li>
                                </ul>
                            </div>
                        </div>
                        <div className="comp">
                            <div className="component second">Site Clearing</div>
                            <div className="list">
                                <ul>
                                    <li>Cleaning of sites before erection and clearing of site after erection</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="list">
                        <ul>
                            <li>
                                Due to high demand to access tailored cleaning services to various industrial in the market was incorporated
                            </li>
                            <li>
                                Our focus is to render cleaning services to various industries industrial, commercial, power plants, production plants, construction sites etc.
                            </li>
                            <li>
                                It is our objective to render our services to the best of our abilities 
                            </li>
                            <li>
                                We employ various skilled and semi skilled labours
                            </li>
                            <li>
                                Areas of focus on the following
                                <br />
                                -	Vegetation control
                                -	Industrial cleaning
                                -	landscaping
                                -	Mine rehabilitation
                                -	Gabions Maintenance and field services Hydroseeding

                            </li>
                        </ul>
                    </div>
                    
                    <h3>Image Gallary </h3>
                    <h5>(Click image for fullscreen)</h5>
                    <div className="images">
                        <img src={image1} onClick={() => FullView2(image1)} alt=""/>
                        <img src={image2} onClick={() => FullView2(image2)} alt=""/>
                        <img src={image3} onClick={() => FullView2(image3)} alt=""/>
                        <img src={image4} onClick={() => FullView2(image4)} alt=""/>
                    </div>
                    <div className="fullImageView" style={{display: block? "block" : "none"}}>
                        <img id="FullImage2" alt=""   />
                        <i className="fa fa-times CloseButton" onClick={() => CloseFullView()}></i>
                    </div>
                </div>
                <div className="end-section2">
                </div>
            </>
     );
}
 
export default Environment;